<template>
  <div class="leg-details-container">
    <div v-if="leg.mode === 'WALK' || leg.mode === 'BICYCLE'">
      <Step
        :step="step"
        :mode="leg.mode"
        :index="index"
        v-for="(step, index) in leg.steps"
        :key="index.toString() + step.streetName"
        @click.native="onStepClick(step)"
      />
    </div>

    <div v-else>
      <div
        v-bind:class="{
          'row-bus': leg.mode === 'BUS',
          'row-rail': leg.mode === 'RAIL',
        }"
        class="leg-details-row row-flex"
        v-for="(stop, index) in leg.intermediateStops"
        :key="index"
        @click="onStepClick(stop)"
      >
        <div class="detail-text">
          <time class="bus-time">{{ time(stop.departure) }} </time>{{ stop.name }}
        </div>
        <span class="tool-tip">Zoom til i kort</span>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import Step from '@/components/Itinerary/Step.vue';

export default {
  name: 'leg-details',
  components: { Step },
  props: { leg: Object },
  methods: {
    time: function(absoluteTime) {
      const date = new Date(absoluteTime);
      return format(date, 'H:mm');
    },
    onStepClick(step) {
      this.$store.commit('stepClicked', step);
    },
  },
};
</script>

<style lang="scss">
.leg-details-container {
  display: flex;
  flex-direction: column;
}

.row-flex {
  display: flex;
  align-items: center;
  min-height: 46px;
  padding: 16px;
  cursor: pointer;
  position: relative;
}
.row-flex:hover {
  color: #8a28bd;
}

.row-flex:hover .tool-tip {
  bottom: -1.5em;
  display: block;
}

.row-bicycle:hover .tool-tip {
  bottom: -1em;
}

.detail-text {
  margin-left: 12px;
}

.row-bus .detail-text,
.row-rail .detail-text {
  margin-left: 0;
}

small {
  font-weight: 600;
  font-size: 12px;
  display: block;
}
.row-bicycle small {
  color: #f93e92;
}

.row-bus {
  position: relative;
}

.row-bus:before,
.row-rail:before {
  content: '';
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #ff9900;
  position: absolute;
  top: calc(50% - 8px);
  left: -28px;
}

.row-rail:before {
  background-color: #66cc6f;
}

.row-rail {
  position: relative;
}

.bus-time {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -84px;
}

@media only screen and (max-width: $mobile-max-width) {
  .tool-tip,
  .row-flex:hover .tool-tip {
    display: none;
  }

  .bus-time {
    left: -76px;
  }

  .row-bus:before,
  .row-rail:before {
    left: -26px;
  }
}
</style>
